'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var Badge$1 = styled__default['default'].span.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  align-content: center;\n  display: ", ";\n  font-family: ", ";\n  font-size: 1rem;\n  font-weight: 500;\n  min-height: 24px;\n  position: relative;\n  width: ", ";\n"])), function (props) {
  return props.elevated || !props.hasChildren ? 'inline-flex' : 'flex';
}, function (props) {
  return props.theme.primaryFontFamily;
}, function (props) {
  return props.elevated ? 'fit-content' : 'initial';
});
var BadgeChildrenContainer = styled__default['default'].span.attrs(defaultTheme.applyDefaultTheme)(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n  align-self: center;\n  height: fit-content;\n  margin-right: 8px;\n"])));
var BadgeLabel = styled__default['default'].span.attrs(defaultTheme.applyDefaultTheme)(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  height: ", ";\n  letter-spacing: 0.32px;\n  margin-left: ", ";\n  position: ", ";\n  right: 0;\n  transform: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n      \n\n  ", "\n\n  ", "\n\n    ", "\n"])), function (props) {
  return props.elevated ? '12px' : '14px';
}, function (props) {
  if (props.fontSize) {
    return "".concat(props.fontSize, "px");
  } else {
    return props.elevated ? '0.625rem' : '0.750rem';
  }
}, function (props) {
  return props.fontWeight ? props.fontWeight : 'normal';
}, function (props) {
  return props.lineHeight ? "".concat(props.lineHeight, "px") : 'normal';
}, function (props) {
  return props.height ? "".concat(props.height, "px") : 'fit-content';
}, function (props) {
  return props.elevated ? '15px' : 'auto';
}, function (props) {
  return props.elevated ? 'absolute' : 'initial';
}, function (props) {
  return props.elevated ? 'translate(33%, -8px)' : 'initial';
}, function (props) {
  return props.width ? styled.css(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n          width: ", "px;\n        "])), props.width) : null;
}, function (props) {
  return props.minWidth ? styled.css(_templateObject5 || (_templateObject5 = defaultTheme._taggedTemplateLiteral(["\n          min-width: ", "px;\n        "])), props.minWidth) : null;
}, function (props) {
  return props.minHeight ? styled.css(_templateObject6 || (_templateObject6 = defaultTheme._taggedTemplateLiteral(["\n          min-height: ", "px;\n        "])), props.minHeight) : null;
}, function (props) {
  var verticalPadding = props.verticalPadding ? "".concat(props.verticalPadding, "px") : props.elevated ? '4px' : '6px';
  var horizontalPadding = props.horizontalPadding ? "".concat(props.horizontalPadding, "px") : props.elevated ? '7px' : '10px';
  return styled.css(_templateObject7 || (_templateObject7 = defaultTheme._taggedTemplateLiteral(["\n      padding: ", " ", ";\n    "])), verticalPadding, horizontalPadding);
}, function (props) {
  return props.theme.themeProp('background', function () {
    var _props$backgroundColo, _props$backgroundColo2;

    var active = props.active;
    var error = props.error;
    var warning = props.warning;
    var defaultBgColor = (_props$backgroundColo = props === null || props === void 0 ? void 0 : (_props$backgroundColo2 = props.backgroundColors) === null || _props$backgroundColo2 === void 0 ? void 0 : _props$backgroundColo2[0]) !== null && _props$backgroundColo !== void 0 ? _props$backgroundColo : props.theme.getColor('gray-600');

    switch (true) {
      case !error && !warning && !active:
        return defaultBgColor;

      case !error && !warning && active:
        return props.theme.getColor('gray-700');

      case error && active:
        return props.theme.getColor('red-500');

      case error:
        return props.theme.getColor('red-200');

      case warning && active:
        return props.theme.getColor('signal-yellow-500');

      case warning:
        return props.theme.getColor('signal-yellow-400');

      default:
        return props.theme.getColor('gray-600');
    }
  }, function () {
    var _props$backgroundColo3, _props$backgroundColo4;

    var active = props.active;
    var error = props.error;
    var warning = props.warning;
    var defaultBgColor = (_props$backgroundColo3 = props === null || props === void 0 ? void 0 : (_props$backgroundColo4 = props.backgroundColors) === null || _props$backgroundColo4 === void 0 ? void 0 : _props$backgroundColo4[1]) !== null && _props$backgroundColo3 !== void 0 ? _props$backgroundColo3 : props.theme.getColor('gray-200');

    switch (true) {
      case !error && !warning && !active:
        return defaultBgColor;

      case !error && !warning && active:
        return props.theme.getColor('white');

      case error && active:
        return props.theme.getColor('red-500');

      case error:
        return props.theme.getColor('red-200');

      case warning && active:
        return props.theme.getColor('signal-yellow-500');

      case warning:
        return props.theme.getColor('signal-yellow-400');

      default:
        return props.theme.getColor('gray-200');
    }
  });
}, function (props) {
  return props.theme.themeProp('color', function () {
    var _props$colors$, _props$colors;

    var defaultColor = (_props$colors$ = props === null || props === void 0 ? void 0 : (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors[0]) !== null && _props$colors$ !== void 0 ? _props$colors$ : props.theme.getColor('white');

    if (props.warning && !props.error || props.error && !props.active) {
      return props.theme.getColor('gray-900');
    } else {
      return defaultColor;
    }
  }, function () {
    var _props$colors$2, _props$colors2;

    var defaultColor = (_props$colors$2 = props === null || props === void 0 ? void 0 : (_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2[1]) !== null && _props$colors$2 !== void 0 ? _props$colors$2 : props.theme.getColor('gray-900');

    if (props.error && props.active) {
      return props.theme.getColor('white');
    } else {
      return defaultColor;
    }
  });
});
var BadgeIcon = styled__default['default'].span.attrs(defaultTheme.applyDefaultTheme)(_templateObject8 || (_templateObject8 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-right: ", ";\n  svg {\n    height: 12px;\n  }\n"])), function (props) {
  return props.useGutter ? '4px' : 0;
});

var Badge = React__default['default'].forwardRef(function Badge(_ref, forwardedRef) {
  var badgeContent = _ref.badgeContent,
      badgeIcon = _ref.badgeIcon,
      children = _ref.children,
      elevated = _ref.elevated,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      lineHeight = _ref.lineHeight,
      active = _ref.active,
      error = _ref.error,
      warning = _ref.warning,
      backgroundColors = _ref.backgroundColors,
      colors = _ref.colors,
      verticalPadding = _ref.verticalPadding,
      horizontalPadding = _ref.horizontalPadding,
      height = _ref.height,
      minHeight = _ref.minHeight,
      width = _ref.width,
      minWidth = _ref.minWidth,
      props = defaultTheme._objectWithoutProperties(_ref, ["badgeContent", "badgeIcon", "children", "elevated", "fontSize", "fontWeight", "lineHeight", "active", "error", "warning", "backgroundColors", "colors", "verticalPadding", "horizontalPadding", "height", "minHeight", "width", "minWidth"]);

  if (typeof badgeContent === 'number') {
    badgeContent = Intl.NumberFormat('en', {
      notation: 'compact'
    }).format(badgeContent);
  }

  return React__default['default'].createElement(Badge$1, defaultTheme._extends({
    ref: forwardedRef,
    elevated: elevated,
    hasChildren: Boolean(children)
  }, props), children && React__default['default'].createElement(BadgeChildrenContainer, null, children), (badgeIcon || badgeContent) && React__default['default'].createElement(BadgeLabel, {
    backgroundColors: backgroundColors,
    colors: colors,
    elevated: elevated,
    fontSize: fontSize,
    fontWeight: fontWeight,
    lineHeight: lineHeight,
    active: active,
    error: error,
    warning: warning,
    verticalPadding: verticalPadding,
    horizontalPadding: horizontalPadding,
    height: height,
    minHeight: minHeight,
    width: width,
    minWidth: minWidth
  }, badgeIcon && React__default['default'].createElement(BadgeIcon, {
    useGutter: !!badgeContent
  }, badgeIcon), badgeContent));
});
Badge.propTypes = process.env.NODE_ENV !== "production" ? {
  badgeIcon: defaultTheme.PropTypes.node,
  badgeContent: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.string, defaultTheme.PropTypes.number, defaultTheme.PropTypes.func, defaultTheme.PropTypes.element]),
  children: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.node, defaultTheme.PropTypes.string]),
  elevated: defaultTheme.PropTypes.bool,
  active: defaultTheme.PropTypes.bool,
  error: defaultTheme.PropTypes.bool,
  warning: defaultTheme.PropTypes.bool,
  fontSize: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),
  fontWeight: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),
  lineHeight: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),
  colors: defaultTheme.PropTypes.arrayOf(defaultTheme.PropTypes.string),
  backgroundColors: defaultTheme.PropTypes.arrayOf(defaultTheme.PropTypes.string),
  verticalPadding: defaultTheme.PropTypes.number,
  horizontalPadding: defaultTheme.PropTypes.number,
  height: defaultTheme.PropTypes.number,
  minHeight: defaultTheme.PropTypes.number,
  width: defaultTheme.PropTypes.number,
  minWidth: defaultTheme.PropTypes.number
} : {};
Badge.defaultProps = {
  elevated: false,
  active: false,
  error: false,
  warning: false,
  badgeIcon: null,
  fontWeight: 'normal',
  lineHeight: 'normal'
};

exports.Badge = Badge;
